import { render, staticRenderFns } from "./Mainabout.vue?vue&type=template&id=50e767ec&scoped=true"
import script from "./Mainabout.vue?vue&type=script&lang=js"
export * from "./Mainabout.vue?vue&type=script&lang=js"
import style0 from "./Mainabout.vue?vue&type=style&index=0&id=50e767ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e767ec",
  null
  
)

export default component.exports